import React from "react";
import { TrainETA } from "../api/metroeta";
import { Header } from "./Header";

type TrainETAListProps = {
  trainETAs?: TrainETA[];
};

const TrainStationTable: React.FC<{ stationName: string; etas: TrainETA[] }> = ({ stationName, etas }) => (
  <div className="stop-section">
    <h3 className="stop-section-name">{stationName}</h3>
    <table className="bus-eta-table">
      <thead>
        <tr>
          <th>Line</th>
          <th>Destination</th>
          <th>ETA</th>
        </tr>
      </thead>
      <tbody>
        {etas.map((eta, i) => (
          <tr key={i}>
            <td className="line-cell">{eta.line}</td>
            <td>{eta.destination}</td>
            <td>{eta.minutes > 0 ? `${eta.minutes} min` : "ARR"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const TrainETAList: React.FC<TrainETAListProps> = ({ trainETAs }) => {
  let content;
  if (trainETAs === undefined) {
    content = <p>Loading...</p>;
  } else if (trainETAs.length === 0) {
    content = <p>There are no trains to display.</p>;
  } else {
    const stations = trainETAs.reduce<Record<string, { stationName: string; etas: TrainETA[] }>>(
      (acc, eta) => {
        if (!acc[eta.stationCode]) acc[eta.stationCode] = { stationName: eta.stationName, etas: [] };
        acc[eta.stationCode].etas.push(eta);
        return acc;
      },
      {},
    );
    content = Object.entries(stations).map(([code, { stationName, etas }]) => (
      <TrainStationTable key={code} stationName={stationName} etas={etas} />
    ));
  }

  return (
    <>
      <Header>Train ETAs</Header>
      {content}
    </>
  );
};
